module.exports = __webpack_public_path__ + "img/icon_badge_d.22cf8af8.svg";